import * as React from 'react';
import { HeroImage } from 'constants/heroImages';
import styles from './styles.module.scss';

interface Props {
  /** `image`: a photo darkened for legible text; `solid`: the navy band. */
  variant: 'image' | 'solid';
  image?: HeroImage;
  /** Minimum height in px (440 on the Home, 215 on the lists). */
  height?: number;
  breadcrumb?: React.ReactNode;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  /** Right column: totals or a minimap. */
  aside?: React.ReactNode;
  /** Top-right action, e.g. the "Ver mapa" button. */
  action?: React.ReactNode;
  /** Sits on the bottom edge, e.g. the Home tabs. */
  tabs?: React.ReactNode;
  /** Narrow header with a smaller title, for the map side panel. */
  compact?: boolean;
}

/** Full-width page header shared by the Home, the lists, the action sheet and the map panels. */
const PageHero = ({ variant, image, height, breadcrumb, title, subtitle, aside, action, tabs, compact }: Props) => (
  <section
    className={`${styles.hero} ${variant === 'solid' ? styles.solid : styles.image} ${compact ? styles.compact : ''}`}
    style={height ? { minHeight: height } : undefined}
  >
    {variant === 'image' && image && (
      <img className={styles.photo} src={image.src} srcSet={image.srcSet} sizes="100vw" alt="" />
    )}
    <div className={styles.content}>
      <div className={styles.main}>
        {breadcrumb && <div className={styles.breadcrumb}>{breadcrumb}</div>}
        <h1 className={styles.title}>{title}</h1>
        {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
      </div>
      {(aside || action) && (
        <div className={styles.side}>
          {action && <div className={styles.action}>{action}</div>}
          {aside}
        </div>
      )}
    </div>
    {tabs && <div className={styles.tabs}>{tabs}</div>}
  </section>
);

export default PageHero;
